import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { ShipImagesService } from 'src/app/Services/ship-images.service';
// import { DeckPlansAccordionItemComponent } from '../deck-plans-accordion-item/deck-plans-accordion-item.component';


type bannerimage = {
  highlight: boolean;
  shpid: Int16Array;
  dplDeck: string;
  dplImage: string;
  dplCategoryImage: string;
  expanded: boolean;
};

@Component({
  selector: 'app-deck-plans',
  templateUrl: './deck-plans.component.html',
  styleUrls: ['./deck-plans.component.css'],
  // providers: [ShipImagesService, DeckPlansAccordionItemComponent],
  providers: [ShipImagesService],
})
export class DeckPlansComponent implements OnInit {
  userdata?: UserData;
  shpid: number | undefined;
  public imgPath : any;

  bannerimages: bannerimage[] | undefined;
  bannerimagedata: any;
  @Input() inputshipId!: number;
  @Input() singledeck: string | undefined;
  @Input() imagetype: string | undefined;
  constructor(
    private appConfigService: AppConfigService,
    private shipImageService: ShipImagesService
  ) {}

  ngOnInit() {
    // 1 - Parse Cached Data For UserInfo...
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    // 2 - If ShipId DNE Then Extract It From UserData...
    if (this.inputshipId == undefined) this.shpid = this.userdata?.shipid!;
    // 3 - Assign Ship Id...
    else this.shpid = this.inputshipId;
    // 4 - Assign image Path from Local Congifuration File...
    this.imgPath = this.appConfigService.imagepath;
    // 5 - Send Get Request To API For Images...
    this.getDeckPlans();
  }

  ngOnChanges(changes: SimpleChanges) {
    // 1 - Subscribe To 'inputshipId' Found within Cache. If Changed Then Enter Workflow... 
    if (changes['inputshipId']) 
    { // 2 - Parse Cache Into Json Object...
      this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
      // 3 - If Ship Id DNE Within Cache Then Assign ShipId to Local Variable...
      if (this.inputshipId == undefined) this.shpid = this.userdata?.shipid!; 
      else this.shpid = this.inputshipId;
      // 4 - IF THE SHIP ID HAS CHANGED THEN CHANGE THE IMAGE PATH...
      this.imgPath = this.appConfigService.imagepath;
      // 5 - Send Get Request To API For SHIP IMAGES...
      this.getDeckPlans();
    }
  }

  getDeckPlans() {
    this.shipImageService
      .getShipImages(this.shpid, 'All')
      .subscribe((bannerimagedata) => this.setDeckPlanImage(bannerimagedata));
  }

  setDeckPlanImage(resdata: any) {
    // 1 - Assign Data From Api To Variable...
    this.bannerimagedata = resdata;
    
    // 2 - If the Request Was Successful Then...
    if (this.bannerimagedata.GetShipImages.Result.Status == 'A') 
      {
        // 3 - Extract  Images From API...  
        this.bannerimages = this.bannerimagedata.GetShipImages.ShipImagesList;
        // 4 - Get last route in url path....
        var currentUrl = window.location.href.split("/").pop();
        // 5 - Set 'Expanded' Flag If the URL Indicates Us To Do So...
        this.bannerimages?.forEach(image => {
          image["expanded"] = (currentUrl == image.dplDeck) ? true : false;
        });
    }
  }

  toggleAccordianItem(index:number)
  { // 1 - LOOP THROUGH EACH ITEM IN ARRAY...
    this.bannerimages?.forEach((item, idx) => {
      // 2 - IF THE LOOP-INDEX IS NOT EQUAL TO THE SELECTED INDEX THEN SET EXPAND TO FALSE... 
      if(index != idx) item.expanded = false;
      // 3- IF THE LOOP INDEX IS EQUAL TO THE SELECTED INDEX, THEN INVERSE THE VALUE...
      if (index == idx) item.expanded = (item.expanded) ? false : true; 
      });
  }
}
